import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Badge,
    Button,
    Card,
    CardBody,
    Container
} from "reactstrap";
import { LogIn } from "lucide-react";

import { useAuth } from "../../context/AuthContext";
import "./SearchContainer.css";
import CreateGroupRequestPage from "../../module/Group Module/Pages/CreateGroupRequestPage"; 
import SmartSearch from "./SmartSearch";



function HomePage() {

    const navigate = useNavigate();

    const { isAuthenticated } = useAuth();
    const [groupKeyword, setGroupKeyword] = useState("");

    const [hasGroups, setHasGroups] = useState(true);
    //------------------------------------------
    // Location Selected
    //------------------------------------------


    //------------------------------------------
    // Group Selected
    //------------------------------------------
    // eslint-disable-next-line
    const handleGroupSelect = (
        groupId: string
    ) => {

        navigate(`/groups/${groupId}`);

    };

    const requestKeyword = groupKeyword;

    return (

        <>

            <Container
                fluid
                className="hero-container"
            >

                <div className="hero-section">

<img
  src={`${process.env.PUBLIC_URL}/assets/PriceWorth_Logo.WebP`}
  alt="PriceWorth Logo"
  style={{
    width: "200px",
    height: "200px",
  }}
   className="priceworth-logo"
/>

                  

                    <div className=" priceworth-tagline"  >

                       <h2 style={{fontWeight:"bolder"}}> Buy Together. <span>Save More.</span> </h2>

                       <p className="desktop-description" style={{lineHeight:"2", fontSize:"16px"}}>Find people planning to buy the same product or service. <br/>
                          Negotiate as a group and unlock <strong>exclusive discounts  </strong>that are not available to individual buyers.<br/>
                          Save big on <strong>NEET/JEE</strong> Coaching AI ML, <strong>CAD</strong>, IT and all <strong>Computer Courses</strong></p>

                          <p className="mobile-description" style={{lineHeight:"2"}}>
  Find people planning to buy the same product.</p>
  <br />
  <p className="mobile-description" style={{lineHeight:"1.5", marginTop:"-45px"}}>Negotiate as a group and unlock <strong>exclusive discounts  </strong>that are not available to individual.</p>
  <br />
  <p className="mobile-description" style={{lineHeight:"1.5", marginTop:"-45px"}} > Save big on <strong>NEET/JEE</strong> Coaching AI ML, <strong>CAD</strong>, IT and all <strong>Computer Courses</strong>.</p>
  



                          
                        

                    </div>

                  {/* <p
  className="mb-5 mx-auto"
  style={{
    fontSize: "1.4rem",
    maxWidth: "800px",
    lineHeight: "1.6",
  }}
>
  Join people planning to buy the same product or service. <br/>
  Negotiate as a group and unlock better prices. <br/>
  <strong>The bigger the group, the better the price.</strong>
</p> */}

                   


                    <SmartSearch 
                        onSearchResult={setHasGroups}
                        onKeywordChanged={setGroupKeyword}
                        
                    />


<div className="popular-searches mt-4">

  <span className="popular-label">
    🔥 Popular:
  </span>

  <span className="popular-badge">
    Car
  </span>
   <span className="popular-badge">
    Bike
  </span>
   <span className="popular-badge">
    Properties 
  </span>

  <span className="popular-badge">
   JEE Coaching
  </span>

  <span className="popular-badge">
    NEET Coaching
  </span>

  <span className="popular-badge">
    AI ML Courses
  </span>

  <span className="popular-badge">
    CAD Courses
  </span>

  

</div>

                </div>

            </Container>

            {
                groupKeyword.trim() !== "" &&
                !hasGroups &&

                (
                    isAuthenticated ?

                        <CreateGroupRequestPage
                            keyword={requestKeyword}
                        />

                        :

                        <Container className="mt-4">

                            <Card
                                className="mx-auto shadow-sm"
                                style={{
                                    maxWidth: 650
                                }}
                            >

                                <CardBody className="text-center p-5">

                                    <h3 className="mb-3">

                                        😔 No groups found

                                    </h3>

                                    <p className="text-muted">

                                        We couldn't find any groups for

                                        <strong>{groupKeyword}</strong>

                                    </p>

                                    <Button
                                        color="primary"
                                        size="lg"
                                        onClick={() =>
                                            navigate("/login")
                                        }
                                    >

                                        <LogIn
                                            size={18}
                                            className="me-2"
                                        />

                                        Login to Create

                                    </Button>

                                </CardBody>

                            </Card>

                        </Container>
                )
            }

        </>

    );

}

export default HomePage;